<template>
    <div class="manage--content">
        <div class="title">
            <h1>{{$t('new.title190')}}</h1>
        </div>
        <!-- Hiển thị danh sách tag level 1 -->
        <div class="primarymenu container primarymenu-add" :class="[ { boxout: mobile }, { 'primarymenu-mb': mobile }, { nqt__mb_ct: mobile }]">
            <ul class="clear" :class="{ boxin: mobile }">
                <li class="setCourse" @click="setCourse('/home/scheduleSetSelfMenu')">
                    <img src="/static/images/settings.png" alt="settings" />
                </li>
                <li class="SchoolBusiness_menu_li" v-for="item in scheduleMenuOne" :key="item.id" :class="{active: scheduleLevelOne == item.id}" @click='scheduleChangeTagLvOne({tagID: item.id, language: $lang(), name: $t("schoolBusiness.all")}), changeCurrentPage()'>
                    {{ item.name }}
                </li>
            </ul>
        </div>
        <!-- Hiển thị danh sách tag level 2 -->
        <div class="secondmenu container">
            <ul class="clear" v-if="scheduleMenuTwo.length">
                <li class="SchoolBusiness_menues_li" v-for="item in scheduleMenuTwo" :key="item.id" :class="{nqt__active: scheduleLevelTwo == item.id}" @click='scheduleChangeTagLvTwo({tagID: item.id, language: $lang(), name: $t("schoolBusiness.all")}), changeCurrentPage()'>
                    {{ item.name }}
                </li>
            </ul>
        </div>
        <!-- Danh sach khoa hoc -->
        <div class="primarylists lkt_custom_card">
            <div class="lessons">
                <ul class="clear" :class="{nqt__mb_ct_list: mobile}">
                    <li v-for="(item, index) in dataRender" :key="item.id">
                        <div v-if="!item.isUrl">
                            <div class="img vaa">
                                <img :src='item.courseCover == undefined || item.courseCover == null || item.courseCover == "" ? "/static/images/temppic.jpg" : item.courseCover' @click="goAicourse(item.courseId)" />
                            </div>
                            <div class="lessontitle" :title="item.courseName" style="-webkit-box-orient: vertical;" @click="goAicourse(item.courseId)">
                                {{ item.courseName }}
                            </div>
                            <!-- <div class="introduce-new" style="-webkit-box-orient: vertical;" @click="goAicourse(item.courseId)" v-html="item.synopsis"></div> -->
                            <div class="like-ps" @click="handleLike(index, item)">
                                <div class="islike">
                                    <div>
                                        <img v-if="item.isLike == 0" src="/static/images/good2.png" />
                                        <img v-if="item.isLike == 1" src="/static/images/good1.png" />
                                        <span>{{ item.likeNum }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="hot-position">
                                <div v-if="item.isHot == '1'" class="ishot-r">Hot</div>
                            </div>
                        </div>
                        <div v-else>
                            <div class="img vaa">
                                <span v-html="item.courseCover"></span>
                            </div>
                            <div class="lessontitle" :title="item.courseName" style="-webkit-box-orient: vertical;" @click="goAicourse(item.courseId)">
                                {{ item.courseName }}
                            </div>
                            <div class="like-ps" @click="handleLike(index, item)">
                                <div class="islike">
                                    <div>
                                        <img v-if="item.isLike == 0" src="/static/images/good2.png" />
                                        <img v-if="item.isLike == 1" src="/static/images/good1.png" />
                                        <span>{{ item.likeNum }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="hot-position">
                                <div v-if="item.isHot == '1'" class="ishot-r">Hot</div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
            <!-- Phân trang -->
            <div  style="text-align: center; margin-top: 10px;" v-if="coursePrivate.length > 0">
                <el-pagination background @current-change="handleCurrentChange" :current-page="page" :page-size="pageSize" layout="pager" :total="totalPage.length"></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import {lang} from '@/assets/languages/getLanguageType.js';
import { mapState, mapActions, mapMutations } from "vuex";
import loading from "@/components/loading/loading";

Vue.prototype.$lang = lang;
export default {
    data() {
        return {
            listCouses : [],
            pageSize: 4,
            totalPage: [],
            page: 1,
        };
    },
    components: {
        loading,
    },
    computed: {
        // Render dữ liệu
        dataRender() {
            if (this.myScheduleCourses.length) {
                this.totalPage = this.myScheduleCourses;
                return this.totalPage.slice(this.pageSize * this.page - this.pageSize, this.pageSize * this.page);
            }
            return [];
        },
        // Lấy dữ liệu từ store
        ...mapState({
            coursePrivate: (state) => state.schoolBussiness.coursePrivate,
            myCourses: (state) => state.schoolBussiness.myCourses,
            courseCompleted: (state) => state.schoolBussiness.courseCompleted,
            loading: (state) => state.schoolBussiness.loading,
            mobile: (state) => state.header.mobile,
            menuOne: (state) => state.schoolBussiness.menuOne,
            menuTwo: (state) => state.schoolBussiness.menuTwo,
            levelOne: (state) => state.schoolBussiness.levelOne,
            levelTwo: (state) => state.schoolBussiness.levelTwo,
            scheduleMenuOne: (state) => state.schoolBussiness.scheduleMenuOne,
            scheduleMenuTwo: (state) => state.schoolBussiness.scheduleMenuTwo,
            scheduleLevelOne: (state) => state.schoolBussiness.scheduleLevelOne,
            scheduleLevelTwo: (state) => state.schoolBussiness.scheduleLevelTwo,
            myScheduleCourses: (state) => state.schoolBussiness.myScheduleCourses,
            scheduleCourseCompleted: (state) => state.schoolBussiness.scheduleCourseCompleted,
        }),
    },

    methods: {
        ...mapActions("schoolBussiness", [
                "changeTagLvOne", 
                "changeTagLvTwo", 
                "dislike", 
                "like",
                "initSchedule",
                "scheduleChangeTagLvOne", 
                "scheduleChangeTagLvTwo", 
                "switchScheduleCourses",
            ]),
        ...mapMutations("schoolBussiness", ["setPage"]),

        // Đi đến chi tiết khóa học
        goAicourse: function (courseId) {
            this.$router.push({
                name: "schedule/schedule_aicourse",
                query: {
                    buyCourseId: JSON.stringify(courseId),
                    buyCollegeId: JSON.stringify(1),
                },
            });
        },

        handleCurrentChange(val) {
            this.page = val;
        },

        changeCurrentPage () {
            this.page = 1;
        },

        // Like hoac unlike khoa hoc
        handleLike: function (index, item) {
            if (item.isLike == 1) {
                this.dislike({ item: item, index: index });
            } else {
                this.like({ item: item, index: index });
            }
        },

        // Đến trang setting danh mục
        setCourse: function (url) {
            this.$router.push({
                path: url,
                query: {
                    fromPagetype: JSON.stringify(2),
                    isPcflag: JSON.stringify(0),
                },
            });
        },
    },
};
</script>
<style scoped>
    .primarylists .lessons .lessontitle {
        -webkit-line-clamp: 3 !important;
    }
    .lkt_disable {
        display: none;
    }
    .lkt_enable {
        display: unset;
    }
    .nqt__active {
        background: #00a8ff !important;
        color: #fff !important;
    }
    .primarymenu-mb {
        height: auto !important;
    }
    .primarymenu {
        position: relative;
    }
    .primarymenu-add {
        height: auto !important;
        overflow: hidden;
        margin-top: 10px !important;
    }

    .primarymenu ul {
        margin-right: 10px;
        margin-left: 10px;
    }
    .primarymenu .showAllCourse {
        position: absolute;
        right: 10px;
        top: 5px;
        cursor: pointer;
    }
    .primarymenu .showAllCourse img {
        width: 19px;
    }
    .primarymenu ul li {
        float: left;
        padding: 5px 15px;
        margin: 0 3px 3px 0 !important;
        background: #e0e0e0;
        color: #333;
        border-radius: 5px;
        cursor: pointer;
        margin-bottom: 10px;
        font-size: 14px;
    }
    .primarymenu ul li:hover {
        background: #00a8ff;
        color: #fff;
    }
    .primarymenu ul li.active {
        background: #00a8ff;
        color: #fff;
        border: none;
    }
    .setCourse {
        background: #eb2f06 !important;
        padding: 3px !important;
        width: 25px;
        height: 25px;
        border-radius: 5px;
        cursor: pointer;
    }
    .setCourse img {
        width: 19px;
    }
    .secondmenu .clear {
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        justify-content: flex-start;
        padding: 5px;
        background: #eee;
        border-radius: 5px;
    }
    .secondmenu ul li {
        padding: 5px;
        border-radius: 5px;
        background: #fff;
        margin: 0 3px 3px 0;
    }
    .lessons {
        margin-top: 10px;
    }
    .lkt_custom_card .lessons ul li > div {
        box-shadow: 0px 5px 10px #dadae8;
    }
    .lkt_custom_card .lessons ul li .img img {
        object-fit: cover;
    }
    .lkt_custom_card .lessontitle {
        text-align: left;
    }
    .title {
        border-bottom: 1px solid #DCDFE6;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .manage--content {
        box-shadow: 0px 5px 5px #dadae8;
    }
    .manage--search-content--left input {
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        width: 100%;
    }
    .card-avtar {
        width: 160px;
    }
    .card-tt {
        width: calc(100% - 160px);
    }
    .lkt-hiddenText {
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        -webkit-line-clamp: 1 !important;
    }
    .nqt--card-discription {
        display: -webkit-box !important;
        -webkit-box-orient: vertical !important;
        padding: 0 0 0px !important;
        overflow: hidden !important;
        color: #333 !important;
        -webkit-line-clamp: 3 !important;
        line-height: 18px;
        width: 100%;
        margin-bottom: 5px;
    }
    .nqt--card--student {
        cursor: pointer;
        border: 1px solid #d7d7d7;
        /* min-height: 300px; */
    }
    .nqt--card-discription i {
        font-style: unset;
    }
    .nqt--card-discription i.isTeacher {
        color: #00a8ff;
    }
    .nqt--title {
        text-align: center;
        /* margin: 10px auto; */
        text-transform: uppercase;
        height: 36px;
        padding: 2px;
    }
    .stBg .nqt--card-title {
        color: #1f1313;
    }
    .stLn .nqt--card-title {
        color: #da251d;
    }
    .stEnd .nqt--card-title {
        color: #118e07;
    }
    .unactive {
        filter: grayscale(100%);
    }
    .select-new {
        width: 25% !important;
    }
    .select-new.mobile {
        width: 100% !important;
        margin-top: 1rem;
    }
    .dtp {
        margin-top: 20px;
        float: none;
    }
    .dot--lesson_begin {
        background: #1f1313;
    }
    .dot--lesson_learning {
        background: #da251d;
    }
    .dot--lesson_end {
        background: #118e07;
    }

    .noteDot span {
        padding-left: 10px;
        padding-right: 20px;
        cursor: pointer;
        font-size: 15px;
    }

    /* switch */
    .menu-switch-school {
        display: block;
        position: relative;
        width: 46px;
        height: 27px;
        border: 1px solid #dfdfdf;
        outline: 0;
        border-radius: 16px;
        box-sizing: border-box;
        background-color: #dfdfdf;
        transition: background-color 0.1s, border 0.1s;
        cursor: pointer;
    }
    .menu-switch-school:before {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 44px;
        height: 25px;
        border-radius: 15px;
        transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
    }
    .menu-switch-school:after {
        content: " ";
        position: absolute;
        top: 0;
        left: 0;
        width: 24px;
        height: 24px;
        border-radius: 15px;
        background-color: #ffffff;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
        transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
    }
    .menu-switch-school-on {
        border-color: #79c9ff;
        background-color: #79c9ff;
    }
    .lesson_begin.menu-switch-school-on:before {
        border-color: #1f1313;
        background-color: #1f1313;
    }
    .lesson_learning.menu-switch-school-on:before {
        border-color: #da251d;
        background-color: #da251d;
    }
    .lesson_end.menu-switch-school-on:before {
        border-color: #118e07;
        background-color: #118e07;
    }
    .menu-switch-school-on:after {
        transform: translateX(20px);
    }
    .controlType {
        display: flex;
    }
    .controlType .dtp {
        margin-top: 0;
        margin-left: 20px;
    }
    .loading--lesson {
        position: absolute;
    }
    /* toptip */
    /* Tooltip container */
    .tooltip {
        position: relative;
        display: inline-block;
    }

    /* Tooltip text */
    .tooltip .tooltiptext {
        visibility: hidden;
        width: auto;
        background-color: black;
        color: #fff;
        text-align: center;
        padding: 5px;
        border-radius: 6px;

        /* Position the tooltip text - see examples below! */
        position: absolute;
        z-index: 1;
        top: 40%;
        right: 0;
        left: 0;
    }

    .tooltip .lkt-tooltip {
        top: 83%;
        left: 43%;
        visibility: hidden;
        width: auto;
        background-color: black;
        color: #fff;
        text-align: center;
        padding: 5px;
        border-radius: 6px;

        /* Position the tooltip text - see examples below! */
        position: absolute;
        z-index: 1;
    }

    .tooltip .tooltiptext::after {
        content: " ";
        position: absolute;
        bottom: 100%; /* At the top of the tooltip */
        left: 50%;
        margin-left: -5px;
        border-width: 5px;
        border-style: solid;
        border-color: transparent transparent black transparent;
    }

    /* Show the tooltip text when you mouse over the tooltip container */
    .uio9:hover .tooltiptext {
        visibility: visible;
    }
    .uio9 {
        -webkit-box-orient: vertical !important;
    }
    .uinqt {
        height: 54px;
    }
    .imgf {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .tooltiptext.pjjj__nqt {
        text-align: unset !important;
    }
    .tooltiptext.lkt-tooltip {
        text-align: unset !important;
    }
    .nqt-pst-a {
        position: absolute !important;
    }

</style>



// WEBPACK FOOTER //
// src/components/schoolBusiness/mobile/content/coursePrivate.vue